export const currency = (n = 0) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export const titleCase = (s = '') =>
  String(s).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const shortDate = (d) =>
  (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '');

export const dayMonth = (d) =>
  (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : '');

export const dateTime = (d) =>
  (d ? new Date(d).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  }) : '');

export const timeAgo = (d) => {
  if (!d) return '';
  const mins = Math.floor((Date.now() - new Date(d).getTime()) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  if (mins < 1440) return `${Math.floor(mins / 60)}h ago`;
  if (mins < 43200) return `${Math.floor(mins / 1440)}d ago`;
  return shortDate(d);
};

export const discountPercent = (mrp, price) => {
  if (!mrp || mrp <= price) return 0;
  return Math.round(((mrp - price) / mrp) * 100);
};

export const salaryText = (job) => {
  if (!job?.salaryMin && !job?.salaryMax) return 'Salary negotiable';
  const period = job.salaryPeriod === 'day' ? 'day' : job.salaryPeriod === 'year' ? 'yr' : 'month';
  if (job.salaryMin && job.salaryMax) return `${currency(job.salaryMin)} - ${currency(job.salaryMax)} / ${period}`;
  return `${currency(job.salaryMin || job.salaryMax)} / ${period}`;
};

export const initials = (name = '') =>
  name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '👤';

export const nextDays = (count = 14) => {
  const days = [];
  for (let i = 0; i < count; i += 1) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    days.push({
      date: d,
      iso: d.toISOString().slice(0, 10),
      day: d.toLocaleDateString('en-IN', { weekday: 'short' }),
      num: d.getDate(),
      month: d.toLocaleDateString('en-IN', { month: 'short' }),
      isToday: i === 0,
    });
  }
  return days;
};
